import React from 'react';
import { useCreditRequest } from '../../../hooks/useCreditRequest';
import CreditsPicker, { CreditsPickerProps } from './CreditsPicker';

/**
 * The credits picker with its "Request more credits" state attached: whether a
 * request is already open, and the click itself. Only the picker's own mount
 * reads it, so a step that never shows a picker never asks the server.
 */
export const ConnectedCreditsPicker: React.FC<Omit<CreditsPickerProps, 'creditRequest'>> = (props) => {
  const creditRequest = useCreditRequest();
  return <CreditsPicker {...props} creditRequest={creditRequest} />;
};

export default ConnectedCreditsPicker;
